var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoucherCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5C4.75 4.86193 4.86193 4.75 5 4.75H7C7.41421 4.75 7.75 4.41421 7.75 4C7.75 3.58579 7.41421 3.25 7 3.25H5C4.0335 3.25 3.25 4.0335 3.25 5V9C3.25 9.9665 4.0335 10.75 5 10.75H7C7.41421 10.75 7.75 10.4142 7.75 10C7.75 9.58579 7.41421 9.25 7 9.25H5C4.86193 9.25 4.75 9.13807 4.75 9V5Z",
    fill: "#A3B0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.75C15.1381 4.75 15.25 4.86193 15.25 5V9C15.25 9.13807 15.1381 9.25 15 9.25H13C12.5858 9.25 12.25 9.58579 12.25 10C12.25 10.4142 12.5858 10.75 13 10.75H15C15.9665 10.75 16.75 9.9665 16.75 9V5C16.75 4.0335 15.9665 3.25 15 3.25H13C12.5858 3.25 12.25 3.58579 12.25 4C12.25 4.41421 12.5858 4.75 13 4.75H15Z",
    fill: "#A3B0C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9Z",
    fill: "#A3B0C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V12C20 13.1046 19.1046 14 18 14H2C0.895431 14 0 13.1046 0 12V2ZM2 1.5H18C18.2761 1.5 18.5 1.72386 18.5 2V12C18.5 12.2761 18.2761 12.5 18 12.5H2C1.72386 12.5 1.5 12.2761 1.5 12V2C1.5 1.72386 1.72386 1.5 2 1.5Z",
    fill: "#A3B0C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherCode);
export default __webpack_public_path__ + "static/media/voucher-code.fd6dee0cc663b073fb4b1358600dfb1e.svg";
export { ForwardRef as ReactComponent };